// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"97927d43","453":"94f6ee1f"}[chunkId] + ".chunk.js";
};